export default {
    FIELD_COLLECTION: "fieldCollection"
}
